import { Image as ChakraImage } from '@chakra-ui/react';

export const Image = ChakraImage;
